import { UserContext } from '@providers/userContextProvider';
import { useContext, useMemo } from 'react';

export const usePermission = (permission: string) => {
  const { permissions } = useContext(UserContext);

  return useMemo(() => permissions.has(permission), [permissions, permission]);
};
